const dateTime = {
    WEEK : "MM/DD",
    HOURS : "HH:mm",
    DATE : "DD MMM YYYY",
}

export default dateTime;
